var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
;
import { GlobalService } from '../../../global.service';
import { ApilistService } from '../../../../service/Api/apilist.service';
import { FormControl } from '@angular/forms';
import { DropdownSearchService } from '../../../dropdown-search.service';
var UpdatelocationComponent = /** @class */ (function () {
    function UpdatelocationComponent(router, http, globalservice, route, apiList, dropdownService) {
        var _this = this;
        this.router = router;
        this.http = http;
        this.globalservice = globalservice;
        this.route = route;
        this.apiList = apiList;
        this.dropdownService = dropdownService;
        this.IdMerchant = +parseInt(sessionStorage.getItem("referMerchantId"));
        this.companyName = sessionStorage.getItem("companyName");
        // IdLocation = sessionStorage.getItem("refrenceidlocation");
        this.IdMasterMerchant = +sessionStorage.getItem("referMasterMerchantId");
        this.mask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        this.selectedday = [];
        this.searchCountryControl = new FormControl();
        this.searchStateSearchCtrl = new FormControl();
        this.searchCityControl = new FormControl();
        this.myOptions = [
            { id: "0", name: 'Sunday' },
            { id: "1", name: 'Monday' },
            { id: "2", name: 'Tuesday' },
            { id: "3", name: 'Wednesday' },
            { id: "4", name: 'Thursday' },
            { id: "5", name: 'Friday' },
            { id: "6", name: 'Saturday' },
        ];
        this.cityname_auto = '';
        this.statename_auto = '';
        this.postal_code_auto = '';
        this.street_number_auto = '';
        this.route_auto = '';
        this.map_error = 0; //map validation
        //abc = new google.maps.places.AutocompleteService();
        this.check_redirect = 'current';
        this.c_code = 1;
        this.lat_value = true;
        this.long_value = true;
        this.countryname = '';
        this.statename = '';
        this.cityname = '';
        this.IsAddressChange = false;
        this.chainList = [];
        this.Latitude = '';
        this.Longitude = '';
        this.AddressValidated = false;
        this.route.params.subscribe(function (get) {
            _this.IdLocation = get.id;
        });
        this.Dailing_codelist();
    }
    UpdatelocationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.refreshChainlist();
        this.HidePopups();
        this.dateTimeFunction();
        var that = this;
        // this.myOptions = [
        //   { id: "0", name: 'Sunday' },
        //   { id: "1", name: 'Monday' },
        //   { id: "2", name: 'Tuesday' },
        //   { id: "3", name: 'Wednesday' },
        //   { id: "4", name: 'Thursday' },
        //   { id: "5", name: 'Friday' },
        //   { id: "6", name: 'Saturday' },
        // ];
        this.globalservice.getCountry().then(function (res) {
            _this.countrylists = res;
            _this.dropdownService.countryObject.next(_this.countrylists);
            _this.dropdownService.CountryArrayObj.next(_this.countrylists.slice());
            _this.searchCountryControl = _this.dropdownService.searchCountryControl;
            _this.searchCountryControl.valueChanges
                .subscribe(function () {
                _this.dropdownService.countryFilter();
            });
        });
        $(function () {
            $("#C0").click(function () {
                $("#txt_sale").attr('disabled', 'disabled');
                $("#txt_profit").attr('disabled', 'disabled');
                $("#sel_currency").attr('disabled', 'disabled');
                $("#txt_MonthlyFee").attr('disabled', 'disabled');
                that.CommisiionSplit1 = '';
                that.CommisiionSplit2 = '';
                that.CommisiionSplit3 = '';
                that.CommisiionSplit = '';
                that.CommisiionSplitType = '';
            });
            $("#C1").click(function () {
                $("#txt_sale").removeAttr('disabled');
                $("#txt_profit").attr('disabled', 'disabled');
                $("#sel_currency").attr('disabled', 'disabled');
                $("#txt_MonthlyFee").attr('disabled', 'disabled');
            });
        });
        $("#C2").click(function () {
            $("#txt_profit").removeAttr('disabled');
            $("#txt_sale").attr('disabled', 'disabled');
            $("#sel_currency").attr('disabled', 'disabled');
            $("#txt_MonthlyFee").attr('disabled', 'disabled');
        });
        $("#C3").click(function () {
            $("#txt_MonthlyFee").removeAttr('disabled');
            $("#txt_sale").attr('disabled', 'disabled');
            $("#sel_currency").removeAttr('disabled');
            $("#txt_profit").attr('disabled', 'disabled');
        });
        var input = document.getElementById('pac-input');
        var autocomplete = new google.maps.places.Autocomplete(input);
        var that = this;
        autocomplete.addListener('place_changed', function () {
            $('#dots_spinner').show();
            var place = autocomplete.getPlace();
            ////console.log(place);
            if (place.address_components) {
                that.fetch_key(place);
                if (that.check_redirect == 'current') {
                    that.check_redirect = 'auto';
                    that.map_error = 0;
                }
                if (that.check_redirect == 'auto' || that.check_redirect == 'type') {
                    that.check_redirect = 'auto';
                    that.map_error = 0;
                    that.get_lat_long();
                }
                if (that.check_redirect == 'current2') {
                    that.autocheck2 = 1;
                    that.map_error = 0;
                    that.get_lat_long();
                }
            }
            else {
                $('#dots_spinner').hide();
                ////console.log(place.name)
                that.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + place.name + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                    ////console.log(response);
                    that.auto_enter = true;
                    that.geometry_address = response;
                    if (that.geometry_address.status == "OK") {
                        var results_count = that.geometry_address.results.length;
                        if (results_count > 1) {
                            $('#dots_spinner').hide();
                            that.map_error = 2;
                            that.map_error_text = "No match found!";
                            that.Addressfild_clear();
                        }
                        if (results_count == 1) {
                            var codee = that.geometry_address.results[0];
                            that.fetch_key(codee);
                            that.get_lat_long();
                        }
                    }
                    else {
                        $('#dots_spinner').hide();
                        that.FlashError("Invalid Address");
                    }
                });
            }
        });
        this.locationdetailstoupdate();
    };
    UpdatelocationComponent.prototype.HidePopups = function () {
        $("#alert_div").hide();
        $('#dots_spinner').hide();
        $('#addChain').modal('hide');
        $('#myImg').hide();
        $('#main_img_close').hide();
        $('#uploadSuccess').modal('hide');
    };
    UpdatelocationComponent.prototype.dateTimeFunction = function () {
        $('body').on('change', '#timepicker1', function () {
            $('#timepicker1').trigger('click');
        });
        $('body').on('change', '#timepicker2', function () {
            $('#timepicker2').trigger('click');
        });
        $('#timepicker1').timepicker();
        $('#timepicker2').timepicker();
    };
    UpdatelocationComponent.prototype.GetTimezoneID = function (lat, long) {
        var _this = this;
        var time = new Date().getTime();
        var date_timestamp = Math.round(time / 1000);
        this.http.get("https://maps.googleapis.com/maps/api/timezone/json?location=" + lat + "," + long + "&timestamp=" + date_timestamp + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.timezone_address = response;
            ////console.log(this.timezone_address)
            if (_this.timezone_address.status == "OK") {
                _this.timezoneid = _this.timezone_address.timeZoneId;
                _this.dstOffset = _this.timezone_address.dstOffset;
                _this.rawOffset = _this.timezone_address.rawOffset;
            }
            else {
                _this.lat = '';
                _this.long = '';
                _this.FlashError("Please fill valid latitude and longitude value");
            }
        });
    };
    UpdatelocationComponent.prototype.locationdetailstoupdate = function () {
        var _this = this;
        $('#dots_spinner').show();
        this.http.post(this.apiList.LocationDetailUrl, { IdLocation: this.IdLocation }, this.globalservice.Headers())
            .take(1)
            .timeout(25000)
            .map(function (resp) {
            if (resp == null || resp.Response == null) {
                throw { Response: 0, ErrorMessage: 'Null Response' };
            }
            resp.Response = +resp.Response;
            if (resp.Response !== 1) {
                throw resp;
            }
            return resp;
        })
            .subscribe(function (response) {
            _this.posts = response;
            if (_this.posts.Response == 1) {
                ////console.log(this.posts);
                _this.posts = _this.posts.Obj_MachineList;
                console.log("Location update details" + JSON.stringify(_this.posts));
                _this.save_auto = 1;
                _this.LocationName = _this.posts[0].LocationName;
                _this.LocationNumber = _this.posts[0].LocationNumber;
                _this.LocationPhoneNumber = _this.posts[0].LocationPhoneNumber;
                _this.timezoneid = _this.posts[0].TimeZoneId;
                //var dailingcode_count = this.LocationPhoneNumber.length - 12   // for split the country dailing code.
                _this.LocationAddress = _this.posts[0].LocationAddress;
                _this.completeaddress = _this.posts[0].LocationAddress;
                if (_this.posts[0].LocationImageDetail) {
                    if (_this.posts[0].LocationImageDetail.ImageUrl && _this.posts[0].LocationImageDetail.ImageUrl !== '') {
                        _this.locNamee = _this.posts[0].LocationImageDetail.ImageUrl;
                        _this.Name = _this.posts[0].LocationImageName;
                        _this.upload_image = 1;
                    }
                }
                _this.LocationBio = _this.posts[0].Bio;
                _this.LocationWeblink = _this.posts[0].Weblink;
                // this.get_Addressdetail()
                _this.street_number_auto = _this.posts[0].StreetAddress;
                _this.statename_auto = _this.posts[0].State;
                _this.cityname_auto = _this.posts[0].City;
                _this.postal_code_auto = _this.posts[0].Zipcode;
                _this.ContactPerson = _this.posts[0].ContactPerson;
                _this.ContactPersonEmailId = _this.posts[0].ContactPersonEmailId;
                _this.ContactPersonPhoneNumber = _this.posts[0].ContactPersonPhoneNumber;
                _this.optionsModelChain = _this.posts[0].IdChain;
                if (_this.optionsModelChain == null) {
                    _this.optionsModelChain = "None";
                }
                // var dailingcode_count = this.ContactPersonPhoneNumber.length - 12   // for split the country dailing code.
                //this.Zip=this.posts[0].Zipcode;
                _this.WorkingDaysName = _this.posts[0].WorkingDaysName;
                _this.WorkingDays = _this.posts[0].WorkingDays;
                _this.selectedday = _this.WorkingDays.split(',');
                _this.StartTime = _this.posts[0].StartTime;
                _this.EndTime = _this.posts[0].EndTime;
                _this.CommisiionSplitType = _this.posts[0].CommisiionSplitType;
                _this.lat = +_this.posts[0].Latitude;
                _this.long = +_this.posts[0].Longitude;
                _this.check_redirect = 'auto';
                _this.selectedstate = _this.posts[0].State;
                _this.checkState = _this.posts[0].State;
                _this.selectedcity = _this.posts[0].City;
                _this.checkcity = _this.posts[0].City;
                _this.countryname = _this.posts[0].Country;
                _this.checkCountry = _this.posts[0].Country;
                //console.log(this.countryname)
                ////console.log( this.selectedstate, this.selectedcity);
                if (_this.countryname) {
                    var code = _this.country_code.filter(function (item) {
                        return (item.name.toLowerCase().indexOf(_this.countryname.toLowerCase()) > -1);
                    });
                    for (var k = 0; k < code.length; k++) {
                        if (_this.countryname === code[k].name) {
                            _this.selctedcountry = _this.posts[0].Country;
                            _this.c_code = code[k].dial_code;
                            var dailingcode_count = code[k].dial_code;
                            ////console.log(dailingcode_count.length)
                        }
                    }
                    _this.LocationPhoneNumber = _this.LocationPhoneNumber.substring(dailingcode_count.length, _this.LocationPhoneNumber.length);
                    _this.ContactPersonPhoneNumber = _this.ContactPersonPhoneNumber.substring(dailingcode_count.length, _this.ContactPersonPhoneNumber.length);
                }
                if (_this.CommisiionSplitType == '% of sale') {
                    $("#txt_sale").removeAttr('disabled');
                    $("#txt_profit").attr('disabled', 'disabled');
                    $("#sel_currency").attr('disabled', 'disabled');
                    $("#txt_MonthlyFee").attr('disabled', 'disabled');
                    _this.CommisiionSplit1 = _this.posts[0].CommisiionSplit;
                    _this.CommisiionSplit = _this.CommisiionSplit1;
                }
                else if (_this.CommisiionSplitType == '% of Gross Profit') {
                    $("#txt_profit").removeAttr('disabled');
                    $("#txt_sale").attr('disabled', 'disabled');
                    $("#sel_currency").attr('disabled', 'disabled');
                    $("#txt_MonthlyFee").attr('disabled', 'disabled');
                    _this.CommisiionSplit2 = _this.posts[0].CommisiionSplit;
                    ////console.log(this.CommisiionSplit2);
                    _this.CommisiionSplit = _this.CommisiionSplit2;
                }
                else if (_this.CommisiionSplitType == 'Monthly Fees') {
                    $("#txt_MonthlyFee").removeAttr('disabled');
                    $("#txt_sale").attr('disabled', 'disabled');
                    $("#sel_currency").removeAttr('disabled');
                    $("#txt_profit").attr('disabled', 'disabled');
                    _this.CommisiionSplit3 = _this.posts[0].CommisiionSplit;
                    _this.CommisiionSplit = _this.CommisiionSplit3;
                    _this.currencyType = _this.posts[0].CurrencyType;
                    _this.sel_currency = _this.currencyType;
                }
                else if (_this.CommisiionSplitType == '') {
                    $("#txt_sale").attr('disabled', 'disabled');
                    $("#txt_profit").attr('disabled', 'disabled');
                    $("#sel_currency").attr('disabled', 'disabled');
                    $("#txt_MonthlyFee").attr('disabled', 'disabled');
                }
            }
        }, function (err) {
            var Error = _this.globalservice.ProcessError(err);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                }
                _this.globalservice.Logout('No');
                return;
            }
            else {
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        }).add(function () { $('#dots_spinner').hide(); });
    };
    UpdatelocationComponent.prototype.map = function () {
        var _this = this;
        var result = this.check_redirect;
        switch (result) {
            case "type":
                this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.LocationAddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                    _this.geometry_address = response;
                    ////console.log(this.geometry_address);
                    if (_this.geometry_address.status == "OK") {
                        $('#map_modal').modal('show');
                        var results_count = _this.geometry_address.results.length;
                        if (results_count > 1) {
                            _this.getCurrent_location();
                        }
                        if (results_count == 1) {
                            if (_this.save_auto != 1) {
                                _this.lat = _this.geometry_address.results[0].geometry.location.lat;
                                _this.long = _this.geometry_address.results[0].geometry.location.lng;
                            }
                            var codee = _this.geometry_address.results[0];
                            _this.fetch_key(codee);
                            _this.show_map_address(_this.lat, _this.long);
                        }
                    }
                    else {
                        _this.FlashError("Invalid Address");
                    }
                });
                break;
            case "auto":
                $('#map_modal').modal('show');
                this.show_map_address(this.lat, this.long);
                break;
            case "edit":
                $('#map_modal').modal('show');
                this.LocationAddressmap = this.completeaddress;
                this.show_map_address(this.lat, this.long);
                break;
            case "current2":
                $('#map_modal').modal('show');
                this.show_map_address(this.lat, this.long);
                break;
            default:
                $('#map_modal').modal('show');
                this.getCurrent_location();
        }
    };
    UpdatelocationComponent.prototype.getCurrent_location = function () {
        var that = this;
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                that.pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                that.show_map_address(that.pos.lat, that.pos.lng);
            }, function (error) {
                ////console.log(error);
                that.admindetails();
            });
        }
    };
    UpdatelocationComponent.prototype.show_map_address = function (lat, long) {
        this.lat_map = lat;
        this.long_map = long;
        var that = this;
        var map;
        map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: this.lat_map, lng: this.long_map },
            zoom: 8,
        });
        var marker = new google.maps.Marker({
            position: { lat: this.lat_map, lng: this.long_map },
            map: map,
            draggable: true,
        });
        marker.setMap(map);
        google.maps.event.addListener(marker, 'drag', function (event) {
            that.lat_map = event.latLng.lat();
            that.long_map = event.latLng.lng();
            that.get_address();
        });
        that.get_address();
    };
    UpdatelocationComponent.prototype.get_address = function () {
        var _this = this;
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.lat_map + "," + this.long_map + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_address = response;
            if (_this.geometry_address.status == "OK") {
                ////console.log(this.geometry_address);
                _this.LocationAddressmap = _this.geometry_address.results[0].formatted_address;
            }
        });
    };
    UpdatelocationComponent.prototype.save_map_position = function (lat, long, name) {
        if (this.check_redirect == 'current' || this.check_redirect == 'type' || this.check_redirect == 'current2') {
            this.save_map_current(lat, long, name);
            this.GetTimezoneID(lat, long);
        }
        else {
            this.save_map(lat, long, name);
            this.GetTimezoneID(lat, long);
        }
    };
    UpdatelocationComponent.prototype.save_map_current = function (lat, long, name) {
        var _this = this;
        this.map_error = 0;
        this.lat_map = lat;
        this.long_map = long;
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.lat_map + "," + this.long_map + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_address = response;
            ////console.log(this.geometry_address);
            if (_this.geometry_address.status == "OK") {
                $('#map_modal').modal('hide');
                _this.check_switch_case();
                _this.save_auto = 1;
            }
            else {
                _this.FlashError("Invalid Address");
            }
        });
    };
    UpdatelocationComponent.prototype.check_switch_case = function () {
        var result = this.check_redirect;
        switch (result) {
            case "current":
                var codee = this.geometry_address.results[0];
                this.fetch_key(codee);
                this.LocationAddress = this.LocationAddressmap;
                this.check_redirect = 'current2';
                this.lat = this.lat_map;
                this.long = this.long_map;
                break;
            case "current2":
                if (this.save_auto != 1) {
                    var codee = this.geometry_address.results[0];
                    this.fetch_key(codee);
                    this.LocationAddress = this.LocationAddressmap;
                    this.lat = this.lat_map;
                    this.long = this.long_map;
                }
                else {
                    this.calculate_distance_address(this.completeaddress);
                    this.lat = this.lat_map;
                    this.long = this.long_map;
                }
                break;
            case "type":
                var codee = this.geometry_address.results[0];
                this.fetch_key(codee);
                this.LocationAddress = this.LocationAddressmap;
                this.check_redirect = 'auto';
                break;
            default:
                var codee = this.geometry_address.results[0];
                this.fetch_key(codee);
                this.lat = this.lat_map;
                this.long = this.long_map;
        }
    };
    UpdatelocationComponent.prototype.save_map = function (lat, long, name) {
        var _this = this;
        this.map_error = 0;
        this.lat_map = lat;
        this.long_map = long;
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.lat_map + "," + this.long_map + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_address = response;
            ////console.log(this.geometry_address);
            if (_this.geometry_address.status == "OK") {
                $('#map_modal').modal('hide');
                if (_this.save_auto != 1) {
                    _this.lat = _this.lat_map;
                    _this.long = _this.long_map;
                    _this.calculate_distance_address(_this.completeaddress);
                }
                else {
                    _this.lat = _this.lat_map;
                    _this.long = _this.long_map;
                    _this.calculate_distance_address(_this.completeaddress);
                }
            }
            else {
                _this.FlashError("Invalid Address");
            }
            _this.save_auto = 1;
        });
    };
    UpdatelocationComponent.prototype.calculate_distance_address = function (name) {
        var _this = this;
        ////console.log(name);
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + name + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_address = response;
            ////console.log(this.geometry_address);
            if (_this.geometry_address.status == "OK") {
                var results_count = _this.geometry_address.results.length;
                if (results_count > 1) {
                    for (var k = 0; k < _this.geometry_address.results.length; k++) {
                        for (var i = 0; i < _this.geometry_address.results[k].address_components.length; i++) {
                            for (var j = 0; j < _this.geometry_address.results[k].address_components[i].types.length; j++) {
                                if (_this.geometry_address.results[k].address_components[i].types[j] == "postal_code") {
                                    if (_this.postal_code_auto == _this.geometry_address.results[k].address_components[i].long_name) {
                                        var a = _this.geometry_address.results[k].geometry.location.lat;
                                        var b = _this.geometry_address.results[k].geometry.location.lng;
                                        ////console.log(a, b, this.lat_map, this.long_map)
                                        var distance = _this.getDistanceFromLatLonInKm(a, b, _this.lat_map, _this.long_map);
                                        ////console.log(distance);
                                        if (distance > 16) {
                                            _this.map_error = 1;
                                            _this.map_error_text = "Address and coordinates are too far apart!";
                                        }
                                        else {
                                            _this.map_error = 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    var a = _this.geometry_address.results[0].geometry.location.lat;
                    var b = _this.geometry_address.results[0].geometry.location.lng;
                    ////console.log(a, b, this.lat_map, this.long_map)
                    var distance = _this.getDistanceFromLatLonInKm(a, b, _this.lat_map, _this.long_map);
                    ////console.log(distance);
                    if (distance > 16) {
                        _this.map_error = 1;
                        _this.map_error_text = "Address and coordinates are too far apart!";
                    }
                    else {
                        _this.map_error = 0;
                    }
                }
            }
        });
    };
    UpdatelocationComponent.prototype.map_address_serach = function (value) {
        var _this = this;
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + value + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_address = response;
            if (_this.geometry_address.status == "OK") {
                var lat = _this.geometry_address.results[0].geometry.location.lat;
                var long = _this.geometry_address.results[0].geometry.location.lng;
                _this.show_map_address(lat, long);
            }
            else {
                _this.FlashError("Invalid Address");
            }
        });
    };
    UpdatelocationComponent.prototype.Ok = function (lat, long) {
        var lat_range = this.isBetween(lat, 90, -90);
        var long_range = this.isBetween(long, 180, -180);
        if (lat_range == true && long_range == true) {
            this.show_map_address(lat, long);
        }
        else if (lat_range == false && long_range == false) {
            //alert("The latitude and longitude value is invalid");
            this.FlashError("The latitude and longitude value is invalid");
        }
        else if (lat_range == false && long_range == true) {
            //  alert("The latitude  value is invalid");
            this.FlashError("The latitude  value is invalid");
        }
        else if (lat_range == true && long_range == false) {
            // alert("The longitude value is invalid");
            this.FlashError("The longitude value is invalid");
        }
    };
    UpdatelocationComponent.prototype.isBetween = function (n, a, b) {
        return (n - a) * (n - b) <= 0;
    };
    UpdatelocationComponent.prototype.autocomplete_length = function (value) {
        var _this = this;
        if (this.check_redirect == 'current2') {
            if (value.target.value) {
                if (this.auto_enter != true) {
                    this.autocheck2 = 0;
                    this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + value.target.value + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                        _this.geometry_address = response;
                        if (_this.geometry_address.status == "OK") {
                            var results_count = _this.geometry_address.results.length;
                            if (results_count > 1) {
                                $('#dots_spinner').hide();
                                _this.map_error = 2;
                                _this.map_error_text = "No match found!";
                                _this.Addressfild_clear();
                            }
                            if (results_count == 1) {
                                var codee = _this.geometry_address.results[0];
                                _this.fetch_key(codee);
                                _this.addAddressData();
                                var lat_ab = _this.geometry_address.results[0].geometry.location.lat;
                                var long_ab = _this.geometry_address.results[0].geometry.location.lng;
                                var distance = _this.getDistanceFromLatLonInKm(lat_ab, long_ab, _this.lat, _this.long);
                                if (distance > 16) {
                                    _this.map_error = 1;
                                    _this.map_error_text = "Address and coordinates are too far apart!";
                                }
                                else {
                                    _this.map_error = 0;
                                }
                            }
                        }
                        else {
                            _this.FlashError("Invalid Address");
                        }
                    });
                }
                else {
                }
            }
            else {
                this.Addressfild_clear();
            }
        }
        else {
            if (value.target.value) {
                if (this.auto_enter != true) {
                    this.check_redirect = 'type';
                    // this.check_address_valid();
                    $('#dots_spinner').hide();
                    this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + value.target.value + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                        ////console.log(response);
                        _this.geometry_address = response;
                        if (_this.geometry_address.status == "OK") {
                            var results_count = _this.geometry_address.results.length;
                            if (results_count > 1) {
                                $('#dots_spinner').hide();
                                _this.map_error = 2;
                                _this.map_error_text = "No match found!";
                                _this.Addressfild_clear();
                            }
                            if (results_count == 1) {
                                var codee = _this.geometry_address.results[0];
                                _this.fetch_key(codee);
                                _this.get_lat_long();
                            }
                        }
                        else {
                            $('#dots_spinner').hide();
                            _this.FlashError("Invalid Address");
                        }
                    });
                }
            }
            else {
                this.Addressfild_clear();
                this.check_redirect = 'current';
            }
        }
    };
    UpdatelocationComponent.prototype.addAddressData = function () {
        var data = {
            ZipCode: this.postal_code_auto,
            City: this.cityname_auto,
            State: this.statename_auto,
            Country: this.countryname,
            Latitude: this.lat,
            Longitude: this.long,
            PhoneCode: this.c_code
        };
        this.http.post(this.apiList.AddZipCodeUrl, data, this.globalservice.Headers()).subscribe(function (response) {
        });
    };
    UpdatelocationComponent.prototype.Edit_address = function () {
        $('#manual_address_modal').modal('show');
        ////console.log(this.check_redirect, this.autocheck2);
        if (this.check_redirect == 'current' || this.check_redirect == 'edit') {
            this.check_redirect = 'edit';
        }
        else if (this.check_redirect == 'auto') {
            if (this.street_number_auto) {
                this.LocationAddressmanully = this.street_number_auto + " " + this.route_auto;
            }
            else {
                this.LocationAddressmanully = this.route_auto;
            }
            this.Zip = this.postal_code_auto;
            this.ZipDetail();
        }
        else if (this.check_redirect == 'current2' && this.autocheck2 == 1) {
            if (this.street_number_auto) {
                this.LocationAddressmanully = this.street_number_auto + " " + this.route_auto;
            }
            else {
                this.LocationAddressmanully = this.route_auto;
            }
            this.Zip = this.postal_code_auto;
            this.ZipDetail();
        }
        else {
            this.check_address_valid();
        }
    };
    UpdatelocationComponent.prototype.check_address_valid = function () {
        var _this = this;
        if (this.LocationAddress) {
            this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.LocationAddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                _this.geometry_address = response;
                ////console.log(this.geometry_address);
                if (_this.geometry_address.status == "OK") {
                    var results_count = _this.geometry_address.results.length;
                    if (results_count > 1) {
                        _this.map_error = 2;
                        _this.map_error_text = "No match found!";
                    }
                    if (results_count == 1) {
                        if (_this.geometry_address.status == "OK") {
                            // this.partial_match = this.geometry_address.results[0].partial_match;
                            for (var i = 0; i < _this.geometry_address.results[0].address_components.length; i++) {
                                for (var j = 0; j < _this.geometry_address.results[0].address_components[i].types.length; j++) {
                                    if (_this.geometry_address.results[0].address_components[i].types[j] == "country") {
                                        _this.checkCountry = _this.geometry_address.results[0].address_components[i].long_name;
                                    }
                                    if (_this.geometry_address.results[0].address_components[i].types[j] == "postal_code") {
                                        _this.Zip = _this.geometry_address.results[0].address_components[i].long_name;
                                        _this.ZipDetail();
                                    }
                                    if (_this.geometry_address.results[0].address_components[i].types[j] == "street_number") {
                                        _this.street_number_auto = _this.geometry_address.results[0].address_components[i].long_name;
                                    }
                                    if (_this.geometry_address.results[0].address_components[i].types[j] == "route") {
                                        _this.route_auto = _this.geometry_address.results[0].address_components[i].long_name;
                                    }
                                    if (_this.geometry_address.results[0].address_components[i].types[j] == "locality") {
                                        _this.checkcity = _this.geometry_address.results[0].address_components[i].long_name;
                                    }
                                    if (_this.geometry_address.results[0].address_components[i].types[j] == "administrative_area_level_1") {
                                        _this.checkState = _this.geometry_address.results[0].address_components[i].long_name;
                                    }
                                }
                            }
                            if (_this.street_number_auto) {
                                _this.LocationAddressmanully = _this.street_number_auto + " " + _this.route_auto;
                            }
                            else {
                                _this.LocationAddressmanully = _this.route_auto;
                            }
                        }
                    }
                }
                else {
                    _this.FlashError("Invalid Address");
                }
            });
        }
    };
    UpdatelocationComponent.prototype.admindetails = function () {
        var _this = this;
        if (this.IdMasterMerchant == 0) {
            var data = {
                IdMerchant: this.IdMerchant,
            };
        }
        else {
            var data = {
                IdMerchant: this.IdMasterMerchant,
            };
        }
        this.http.post(this.apiList.MerchantDetailUrl, data, this.globalservice.Headers())
            .take(1)
            .timeout(25000)
            .map(function (resp) {
            if (resp == null || resp.Response == null) {
                throw { Response: 0, ErrorMessage: 'Null Response' };
            }
            resp.Response = +resp.Response;
            if (resp.Response !== 1) {
                throw resp;
            }
            return resp;
        })
            .subscribe(function (response) {
            if (response.Response == 1) {
                _this.userdata = response;
                ////console.log(this.userdata)
                var Zipcode_merchant = '' + _this.userdata.obj_MerchantRecord.Zip;
                _this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + Zipcode_merchant + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                    ////console.log(this.geometry_address);
                    _this.geometry_address = response;
                    if (_this.geometry_address.status == "OK") {
                        var lat = _this.geometry_address.results[0].geometry.location.lat;
                        var long = _this.geometry_address.results[0].geometry.location.lng;
                        _this.show_map_address(lat, long);
                    }
                });
            }
        }, function (err) {
            var Error = _this.globalservice.ProcessError(err);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                }
                _this.globalservice.Logout('No');
                return;
            }
            else {
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        }).add(function () { $('#dots_spinner').hide(); });
    };
    UpdatelocationComponent.prototype.ZipDetail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Zipdetails;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("inside zip details value" + this.Zip);
                        if (!this.Zip) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.globalservice.GetZIPDetails(this.Zip)];
                    case 1:
                        Zipdetails = _a.sent();
                        console.log("inside zipdetails if" + Zipdetails);
                        ////console.log(Zipdetails);
                        if (Zipdetails.Response == 1) {
                            // this.selctedcountry = Zipdetails.CountryName;
                            // this.IdCountry = Zipdetails.CountryId;
                            if (Zipdetails.lst_Countries.length == 1) {
                                // for single country
                                this.countrylists = Zipdetails.lst_Countries;
                                this.dropdownService.countryObject.next(this.countrylists);
                                this.dropdownService.CountryArrayObj.next(this.countrylists.slice());
                                this.selctedcountry = Zipdetails.lst_Countries[0].CountryName;
                                this.countryname = Zipdetails.lst_Countries[0].CountryName;
                                this.IdCountry = Zipdetails.lst_Countries[0].IdCountry;
                                // if (this.IdCountry) {
                                //   this.getstates();
                                //   if (Zipdetails.lst_States.length == 1) {
                                //     this.selectedstate = Zipdetails.lst_States[0].StateName;
                                //     this.statename = Zipdetails.lst_States[0].StateName;
                                //     this.IdState = Zipdetails.lst_States[0].IdState;
                                //     if (this.IdState) {
                                //       this.getcity();
                                //       if (Zipdetails.lst_Cities.length == 1) {
                                //         this.selectedcity = Zipdetails.lst_Cities[0].CityName;
                                //         this.cityname = Zipdetails.lst_Cities[0].CityName;
                                //       }
                                //       if (Zipdetails.lst_Cities.length > 1) {
                                //         this.citys = Zipdetails.lst_Cities;
                                //       }
                                //     }
                                //   }
                                //   if (Zipdetails.lst_States.length > 0) {
                                //     this.states = Zipdetails.lst_States
                                //   }
                                // }
                            }
                            if (Zipdetails.lst_Countries.length == 0) { // when no country
                                // this.globalservice.getCountry().then((res:any)=>{
                                //   this.countrylists = res;
                                //  // console.log(res);
                                // });
                                this.globalservice.getCountry().then(function (res) {
                                    _this.countrylists = res;
                                    _this.dropdownService.countryObject.next(_this.countrylists);
                                    _this.dropdownService.CountryArrayObj.next(_this.countrylists.slice());
                                    _this.searchCountryControl = _this.dropdownService.searchCountryControl;
                                    _this.searchCountryControl.valueChanges
                                        .subscribe(function () {
                                        _this.dropdownService.countryFilter();
                                    });
                                });
                                this.selctedcountry = '';
                                this.selectedstate = '';
                                this.selectedcity = '';
                            }
                            if (Zipdetails.lst_Countries.length > 1) { //when multiple country
                                // if (Zipdetails.lst_Countries.length > 1) {
                                Zipdetails.lst_Countries.forEach(function (element) {
                                    console.log(_this.checkCountry);
                                    if (element.CountryName == _this.checkCountry) {
                                        _this.selctedcountry = element.CountryName;
                                        _this.countryname = element.CountryName;
                                        _this.IdCountry = element.IdCountry;
                                    }
                                    else {
                                        console.log(Zipdetails.lst_Countries);
                                        _this.countrylists = Zipdetails.lst_Countries;
                                        _this.dropdownService.countryObject.next(_this.countrylists);
                                        _this.dropdownService.CountryArrayObj.next(_this.countrylists.slice());
                                        _this.searchCountryControl = _this.dropdownService.searchCountryControl;
                                        _this.searchCountryControl.valueChanges
                                            .subscribe(function () {
                                            _this.dropdownService.countryFilter();
                                        });
                                    }
                                });
                            }
                            /*    for state */
                            if (Zipdetails.lst_States.length == 1) { //  for single
                                this.selectedstate = Zipdetails.lst_States[0].StateName;
                                this.statename = Zipdetails.lst_States[0].StateName;
                                this.IdState = Zipdetails.lst_States[0].IdState;
                                this.states = Zipdetails.lst_States;
                                this.dropdownService.stateObject.next(this.states);
                                this.dropdownService.StateArrayObj.next(this.states.slice());
                                this.searchStateSearchCtrl = this.dropdownService.searchStateControl;
                                this.searchStateSearchCtrl.valueChanges
                                    .subscribe(function () {
                                    _this.dropdownService.stateFilter();
                                });
                            }
                            if (Zipdetails.lst_States.length > 1) { //  for multiple
                                Zipdetails.lst_States.forEach(function (element1) {
                                    if (element1.StateName == _this.checkState) {
                                        _this.selectedstate = element1.StateName;
                                        _this.statename = element1.StateName;
                                        _this.IdState = element1.IdState;
                                    }
                                    _this.states = Zipdetails.lst_States;
                                    _this.dropdownService.stateObject.next(_this.states);
                                    _this.dropdownService.StateArrayObj.next(_this.states.slice());
                                    _this.searchStateSearchCtrl = _this.dropdownService.searchStateControl;
                                    _this.searchStateSearchCtrl.valueChanges
                                        .subscribe(function () {
                                        _this.dropdownService.stateFilter();
                                    });
                                });
                            }
                            if (Zipdetails.lst_States.length == 0) { // when no state
                                this.getstates();
                            }
                            /*    for city */
                            if (Zipdetails.lst_Cities.length == 1) {
                                this.selectedcity = Zipdetails.lst_Cities[0].CityName;
                                this.cityname = Zipdetails.lst_Cities[0].CityName;
                                this.IdCity = Zipdetails.lst_Cities[0].CityId;
                                // this.dropdownService.cityObject.next(this.citys);
                                // this.dropdownService.CityArrayObj.next(this.citys.slice());
                                // this.searchCityControl = this.dropdownService.searchCityControl;
                                // this.searchCityControl.valueChanges
                                //     .subscribe(() => {
                                //         this.dropdownService.cityFilter();
                                //     });
                            }
                            if (Zipdetails.lst_Cities.length > 1) { //  for multiple
                                Zipdetails.lst_Cities.forEach(function (element2) {
                                    if (element2.CityName == _this.checkcity) {
                                        _this.selectedcity = element2.CityName;
                                        _this.cityname = element2.CityName;
                                        _this.IdCity = element2.CityId;
                                        // this.IdState = element2.IdState;
                                    }
                                    _this.citys = Zipdetails.lst_Cities;
                                    _this.dropdownService.cityObject.next(_this.citys);
                                    _this.dropdownService.CityArrayObj.next(_this.citys.slice());
                                    _this.searchCityControl = _this.dropdownService.searchCityControl;
                                    _this.searchCityControl.valueChanges
                                        .subscribe(function () {
                                        _this.dropdownService.cityFilter();
                                    });
                                });
                            }
                            else {
                                this.getcity();
                            }
                        }
                        else if (Zipdetails.Response === 35) {
                            if (Zipdetails.ErrorMessage) {
                                this.FlashError(Zipdetails.ErrorMessage);
                                this.globalservice.Logout('Yes');
                            }
                            this.globalservice.Logout('No');
                        }
                        else {
                            this.selctedcountry = '';
                            this.selectedstate = '';
                            this.selectedcity = '';
                            this.AlertText = Zipdetails.ErrorMessage;
                            this.FlashError(Zipdetails.ErrorMessage);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.clearSearch();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UpdatelocationComponent.prototype.confirm_address = function () {
        this.Addressfild_clear();
        // this.completeaddress = this.LocationAddressmanully + " " + this.cityname + ", " + this.statename + " " + this.Zip + " " + this.countryname;
        // if (this.LocationAddressmanully && this.selctedcountry && this.selectedstate) {
        if (this.check_redirect == 'auto' || this.check_redirect == 'current') {
            console.log("hi");
            this.APICAll();
        }
        else {
            console.log("hello");
            this.APICAll();
        }
        //}
    };
    UpdatelocationComponent.prototype.onChangeCountry = function (a) {
        this.IdCountry = a;
        this.selectedstate = '';
        this.selectedcity = '';
        this.getstates();
    };
    UpdatelocationComponent.prototype.getstates = function () {
        var _this = this;
        $('#dots_spinner').show();
        this.http.post(this.apiList.StateUrl, { IdCountry: this.IdCountry }, this.globalservice.Headers())
            .take(1)
            .timeout(25000)
            .map(function (resp) {
            if (resp == null || resp.Response == null) {
                throw { Response: 0, ErrorMessage: 'Null Response' };
            }
            resp.Response = +resp.Response;
            if (resp.Response !== 1) {
                throw resp;
            }
            return resp;
        })
            .subscribe(function (response) {
            _this.states = response.lst_State;
            _this.dropdownService.stateObject.next(_this.states);
            _this.dropdownService.StateArrayObj.next(_this.states.slice());
            _this.searchStateSearchCtrl = _this.dropdownService.searchStateControl;
            _this.searchStateSearchCtrl.valueChanges
                .subscribe(function () {
                _this.dropdownService.stateFilter();
            });
        }, function (err) {
            var Error = _this.globalservice.ProcessError(err);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                }
                _this.globalservice.Logout('No');
                return;
            }
            else {
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        }).add(function () { $('#dots_spinner').hide(); });
    };
    UpdatelocationComponent.prototype.onChangeState = function (b, d) {
        this.IdState = b;
        this.selectedstate = d;
        //this.selectedcity = ''
        this.getcity();
    };
    UpdatelocationComponent.prototype.onchangecity = function (e, id) {
        this.cityname = e;
        this.IdCity = id;
    };
    UpdatelocationComponent.prototype.changeday = function () {
        $('#uncheckall').removeClass("btn_active");
        $('#checkall').removeClass("btn_active");
    };
    UpdatelocationComponent.prototype.selectAll = function () {
        this.selectedday = ["0", "1", "2", "3", "4", "5", "6"];
        $('#checkall').addClass("btn_active");
        $('#uncheckall').removeClass("btn_active");
    };
    UpdatelocationComponent.prototype.deselectAll = function () {
        this.selectedday = [];
        $('#checkall').removeClass("btn_active");
        $('#uncheckall').addClass("btn_active");
    };
    UpdatelocationComponent.prototype.getcity = function () {
        var _this = this;
        $('#dots_spinner').show();
        this.http.post(this.apiList.CityUrl, { IdState: this.IdState }, this.globalservice.Headers())
            .take(1)
            .timeout(25000)
            .map(function (resp) {
            if (resp == null || resp.Response == null) {
                throw { Response: 0, ErrorMessage: 'Null Response' };
            }
            resp.Response = +resp.Response;
            if (resp.Response !== 1) {
                throw resp;
            }
            return resp;
        })
            .subscribe(function (response) {
            _this.citys = response.lst_City;
            _this.dropdownService.cityObject.next(_this.citys);
            _this.dropdownService.CityArrayObj.next(_this.citys.slice());
            _this.searchCityControl = _this.dropdownService.searchCityControl;
            _this.searchCityControl.valueChanges
                .subscribe(function () {
                _this.dropdownService.cityFilter();
            });
        }, function (err) {
            var Error = _this.globalservice.ProcessError(err);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                }
                _this.globalservice.Logout('No');
                return;
            }
            else {
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        }).add(function () { $('#dots_spinner').hide(); });
    };
    UpdatelocationComponent.prototype.goback = function () {
        this.router.navigate([this.companyName + '/dashboard/locations']);
    };
    UpdatelocationComponent.prototype.startTime = function (time) {
        this.StartTime = time;
    };
    UpdatelocationComponent.prototype.endTimelocation = function (tim) {
        this.EndTime = tim;
    };
    // save_click() {
    //   if (this.CommisiionSplit == '' || this.CommisiionSplit == undefined) {
    //     this.AlertText = "";
    //     this.AlertText = "Commission Split is Mandatory !"
    //     this.FlashError()
    //   } else {
    //     $('#dots_spinner').show();
    //     this.newselcteddays = this.selectedday.toString().replace(/\[.*\]/g, '');
    //     return false;
    //     this.http.post<any>(this.UpdateLocationUrl, { IdLocation: this.IdLocation, LocationNumber: this.LocationNumber, LocationName: this.LocationName, LocationAddress: this.LocationAddress, IdCity: this.selectedcity, IdState: this.selectedstate, Zip: this.Zip, IdCountry: this.selectedcountry, LocationPhoneNumber: this.LocationPhoneNumber, ContactPerson: this.ContactPerson, ContactPersonEmailId: this.ContactPersonEmailId, ContactPersonPhoneNumber: this.ContactPersonPhoneNumber, CommisiionSplitType: this.CommisiionSplitType, CurrencyType: this.sel_currency, CommisiionSplit: this.CommisiionSplit, CreatedBy: this.IdMerchant, WorkingDays: this.newselcteddays, StartTime: this.StartTime, EndTime: this.EndTime }, this.globalservice.Headers()).subscribe((response) => {
    //       //console.log(response);
    //       var update = response;
    //       $('#dots_spinner').hide();
    //       if (update.Response == 1) {
    //         this.router.navigate([this.companyName + '/dashboard/locations']);
    //       } else {
    //         this.AlertText = update.ErrorMessage;
    //         this.FlashError();
    //       }
    //     });
    //   }
    // }
    // ondrop(a) {
    // }
    UpdatelocationComponent.prototype.sale = function () {
        this.CommisiionSplit = this.CommisiionSplit1;
    };
    UpdatelocationComponent.prototype.gross = function () {
        this.CommisiionSplit = this.CommisiionSplit2;
    };
    UpdatelocationComponent.prototype.fees = function () {
        this.CommisiionSplit = this.CommisiionSplit3;
    };
    // changeday() {
    //   if (this.selectedday[0] == 9) {
    //     this.selectedday = ["0", "1", "2", "3", "4", "5", "6", "7"]
    //   } else if (this.selectedday[0] == 90) {
    //     this.selectedday = [];
    //   } else {
    //   }
    // }
    UpdatelocationComponent.prototype.clearSearch = function () {
        this.Zip = '';
        this.selctedcountry = '';
        this.selectedcity = '';
        this.selectedstate = '';
        var country = [];
        this.dropdownService.countryObject.next(country);
        this.dropdownService.CountryArrayObj.next(country.slice());
        var state = [];
        this.dropdownService.stateObject.next(state);
        this.dropdownService.StateArrayObj.next(state.slice());
        var city = [];
        this.dropdownService.cityObject.next(city);
        this.dropdownService.CityArrayObj.next(city.slice());
    };
    UpdatelocationComponent.prototype.FlashError = function (message) {
        this.AlertText = '';
        this.AlertText = message;
        $('#alert_div').show();
        $('#alert_div').animate({
            width: '100%'
        }, 'slow');
        setTimeout(function () {
            $('#alert_div').hide();
        }, 3000);
    };
    UpdatelocationComponent.prototype.get_Addressdetail = function () {
        var _this = this;
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.completeaddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_ccc = response;
            var data = _this.geometry_ccc.results[0];
            _this.fetch_key(data);
        });
    };
    UpdatelocationComponent.prototype.get_lat_long = function () {
        var _this = this;
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.completeaddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            ////console.log(this.geometry_address);
            _this.geometry_address = response;
            if (_this.geometry_address.status == "OK") {
                $('#dots_spinner').hide();
                // this.complete_address = this.geometry_address.results[0].formatted_address
                if (_this.save_auto != 1) {
                    var codee = _this.geometry_address.results[0];
                    _this.fetch_key(codee);
                    _this.lat = _this.geometry_address.results[0].geometry.location.lat;
                    _this.long = _this.geometry_address.results[0].geometry.location.lng;
                    _this.GetTimezoneID(_this.lat, _this.long);
                    _this.addAddressData();
                }
                else {
                    var ab = _this.geometry_address.results[0].geometry.location.lat;
                    var cd = _this.geometry_address.results[0].geometry.location.lng;
                    _this.GetTimezoneID(ab, cd);
                    if (_this.check_redirect == 'current2') {
                        var distance = _this.getDistanceFromLatLonInKm(ab, cd, _this.lat, _this.long);
                    }
                    else {
                        var distance = _this.getDistanceFromLatLonInKm(ab, cd, _this.lat, _this.long);
                    }
                    if (distance > 16) {
                        _this.map_error = 1;
                        _this.map_error_text = "Address and coordinates are too far apart!";
                    }
                    else {
                        _this.map_error = 0;
                    }
                }
            }
            else {
                _this.FlashError("Invalid Address");
            }
        });
    };
    UpdatelocationComponent.prototype.fetch_key = function (place) {
        this.IsAddressChange = true;
        this.Addressfild_clear();
        $('#dots_spinner').hide();
        for (var i = 0; i < place.address_components.length; i++) {
            for (var j = 0; j < place.address_components[i].types.length; j++) {
                var result = place.address_components[i].types[j];
                switch (result) {
                    case "postal_code":
                        this.postal_code_auto = place.address_components[i].long_name;
                        break;
                    case "street_number":
                        this.street_number_auto = place.address_components[i].long_name;
                        break;
                    case "route":
                        this.route_auto = place.address_components[i].long_name;
                        break;
                    case "locality":
                        this.cityname_auto = place.address_components[i].long_name;
                        break;
                    case "administrative_area_level_1":
                        this.statename_auto = place.address_components[i].long_name;
                        break;
                    case "country":
                        this.countryname = place.address_components[i].long_name;
                        this.get_dailingcode(place.address_components[i].long_name);
                        break;
                }
            }
        }
        this.completeaddress = this.street_number_auto + " " + this.route_auto + "," + this.cityname_auto + ", " + this.statename_auto + " " + this.postal_code_auto + " " + this.countryname;
        this.completeaddress = this.completeaddress.replace(/  +/g, ' ');
    };
    UpdatelocationComponent.prototype.APICAll = function () {
        var _this = this;
        this.completeaddress = this.LocationAddressmanully + "," + this.selectedcity + ", " + this.selectedstate + " " + this.Zip + " " + this.selctedcountry;
        ////console.log(this.completeaddress);
        this.completeaddress = this.completeaddress.replace(/  +/g, ' ');
        ////console.log("ghgdshgd" + this.completeaddress)
        this.route_auto = '';
        this.street_number_auto = this.LocationAddressmanully;
        this.countryname = this.selctedcountry;
        this.statename_auto = this.selectedstate;
        this.cityname_auto = this.selectedcity;
        this.postal_code_auto = this.Zip;
        this.get_dailingcode(this.countryname);
        // this.cityname_auto = this.cityname;
        // this.selectedcity = this.cityname_auto
        // this.statename_auto = this.statename;
        // this.selectedstate = this.statename_auto
        // this.countryname = this.countryname;
        // this.selctedcountry = this.countryname;
        // this.postal_code_auto = this.Zip;
        this.LocationAddress = this.completeaddress;
        // this.get_dailingcode(this.countryname);
        this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.completeaddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
            _this.geometry_address = response;
            //console.log(this.geometry_address);
            if (_this.geometry_address.status == "OK") {
                //console.log(this.geometry_address.results.length);
                $('#dots_spinner').hide();
                $('#manual_address_modal').modal('hide');
                _this.check_redirect = 'edit';
                var results_count = _this.geometry_address.results.length;
                if (results_count > 1) {
                    for (var k = 0; k < _this.geometry_address.results.length; k++) {
                        for (var i = 0; i < _this.geometry_address.results[k].address_components.length; i++) {
                            for (var j = 0; j < _this.geometry_address.results[k].address_components[i].types.length; j++) {
                                if (_this.geometry_address.results[k].address_components[i].types[j] == "postal_code") {
                                    if (_this.Zip == _this.geometry_address.results[k].address_components[i].long_name) {
                                        if (_this.save_auto != 1) {
                                            _this.lat = _this.geometry_address.results[k].geometry.location.lat;
                                            _this.long = _this.geometry_address.results[k].geometry.location.lng;
                                            //console.log(this.lat, this.long)
                                        }
                                        else {
                                            var latt = _this.geometry_address.results[k].geometry.location.lat;
                                            var longg = _this.geometry_address.results[k].geometry.location.lng;
                                            var distance = _this.getDistanceFromLatLonInKm(latt, longg, _this.lat, _this.long);
                                            //console.log(distance);
                                            if (distance > 16) {
                                                _this.map_error = 1;
                                                _this.map_error_text = "Address and coordinates are too far apart!";
                                            }
                                            else {
                                                _this.map_error = 0;
                                            }
                                        }
                                    }
                                    else {
                                        if (_this.save_auto != 1) {
                                            _this.lat = _this.geometry_address.results[k].geometry.location.lat;
                                            _this.long = _this.geometry_address.results[k].geometry.location.lng;
                                            //console.log(this.lat, this.long)
                                        }
                                        else {
                                            var latt = _this.geometry_address.results[k].geometry.location.lat;
                                            var longg = _this.geometry_address.results[k].geometry.location.lng;
                                            var distance = _this.getDistanceFromLatLonInKm(latt, longg, _this.lat, _this.long);
                                            //console.log(distance);
                                            if (distance > 16) {
                                                _this.map_error = 1;
                                                _this.map_error_text = "Address and coordinates are too far apart!";
                                            }
                                            else {
                                                _this.map_error = 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    if (_this.save_auto != 1) {
                        _this.lat = _this.geometry_address.results[0].geometry.location.lat;
                        _this.long = _this.geometry_address.results[0].geometry.location.lng;
                        //console.log(this.lat, this.long)
                    }
                    else {
                        var latt = _this.geometry_address.results[0].geometry.location.lat;
                        var longg = _this.geometry_address.results[0].geometry.location.lng;
                        var distance = _this.getDistanceFromLatLonInKm(latt, longg, _this.lat, _this.long);
                        //console.log(distance);
                        if (distance > 16) {
                            _this.map_error = 1;
                            _this.map_error_text = "Address and coordinates are too far apart!";
                        }
                        else {
                            _this.map_error = 0;
                        }
                    }
                }
            }
            else {
                $('#dots_spinner').hide();
                _this.FlashError("Invalid Address");
            }
        });
    };
    UpdatelocationComponent.prototype.getDistanceFromLatLonInKm = function (lat1, lon1, lat2, lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
        var dLon = this.deg2rad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    };
    UpdatelocationComponent.prototype.deg2rad = function (deg) {
        return deg * (Math.PI / 180);
    };
    UpdatelocationComponent.prototype.get_dailingcode = function (name) {
        var _this = this;
        //console.log(this.countryname);
        var code = this.country_code.filter(function (item) {
            return (item.name.toLowerCase().indexOf(_this.countryname.toLowerCase()) > -1);
        });
        for (var k = 0; k < code.length; k++) {
            if (name === code[k].name) {
                this.c_code = code[k].dial_code;
            }
        }
        // $('#dots_spinner').hide();
    };
    UpdatelocationComponent.prototype.Dailing_codelist = function () {
        var _this = this;
        this.http.get('./assets/country.txt')
            .subscribe(function (response) {
            _this.country_code = response;
        });
    };
    UpdatelocationComponent.prototype.Addressfild_clear = function () {
        this.completeaddress = '';
        this.street_number_auto = '';
        this.route_auto = '';
        this.cityname_auto = '';
        this.statename_auto = '';
        this.countryname = '';
        this.postal_code_auto = "";
    };
    UpdatelocationComponent.prototype.Address = function () {
        var _this = this;
        var time = new Date().getTime();
        var date_timestamp = Math.round(time / 1000);
        if (this.check_redirect == 'current2') {
            this.lat = this.lat_current;
            this.long = this.long_current;
        }
        if (this.lat && this.long) {
            this.http.get("https://maps.googleapis.com/maps/api/timezone/json?location=" + this.lat + "," + this.long + "&timestamp=" + date_timestamp + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                _this.timezone_address = response;
                //console.log(this.timezone_address)
                if (_this.timezone_address.status == "OK") {
                    _this.timezoneid = _this.timezone_address.timeZoneId;
                    _this.dstOffset = _this.timezone_address.dstOffset;
                    _this.rawOffset = _this.timezone_address.rawOffset;
                    _this.save();
                }
                else {
                    _this.lat = '';
                    _this.long = '';
                    _this.FlashError("Please fill valid latitude and longitude value");
                }
            });
        }
        else {
            this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.LocationAddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                //console.log(this.geometry_ccc);
                _this.geometry_ccc = response;
                if (_this.geometry_ccc.status == "OK") {
                    var codee = _this.geometry_ccc.results[0];
                    _this.fetch_key(codee);
                    // this.completeaddress = this.geometry_ccc.results[0].formatted_address
                    _this.lat = _this.geometry_ccc.results[0].geometry.location.lat;
                    _this.long = _this.geometry_ccc.results[0].geometry.location.lng;
                    _this.http.get("https://maps.googleapis.com/maps/api/timezone/json?location=" + _this.lat + "," + _this.long + "&timestamp=" + date_timestamp + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                        _this.timezone_address = response;
                        //console.log(this.timezone_address)
                        if (_this.timezone_address.status == "OK") {
                            _this.timezoneid = _this.timezone_address.timeZoneId;
                            _this.dstOffset = _this.timezone_address.dstOffset;
                            _this.rawOffset = _this.timezone_address.rawOffset;
                            _this.save();
                        }
                        else {
                            _this.lat = '';
                            _this.long = '';
                            _this.FlashError("Please fill valid latitude and longitude value");
                        }
                    });
                }
                else {
                    _this.FlashError("Invalid Address");
                }
            });
        }
    };
    UpdatelocationComponent.prototype.save = function () {
        var _this = this;
        this.ZipcodeExist();
        setTimeout(function () {
            if (_this.AddressValidated) {
                if (_this.optionsModelChain == "None") {
                    _this.optionsModelChain = null;
                }
                _this.LocationPhoneNumber = _this.c_code + _this.LocationPhoneNumber;
                _this.ContactPersonPhoneNumber = _this.c_code + _this.ContactPersonPhoneNumber;
                if (_this.street_number_auto) {
                    var street_address = _this.street_number_auto + " " + _this.route_auto;
                }
                else {
                    var street_address = _this.route_auto;
                }
                // if (this.CommisiionSplit == '' || this.CommisiionSplit == undefined) {
                //   this.AlertText = "";
                //   this.AlertText = "Commission Split is Mandatory !"
                //   this.FlashError()
                // } else {
                if (_this.upload_image === 1) {
                    $('#dots_spinner').show();
                    _this.newselcteddays = _this.selectedday.toString().replace(/\[.*\]/g, '');
                    //console.log(this.newselcteddays);
                    _this.http.post(_this.apiList.UpdateLocationUrl, { IsAddressChange: _this.IsAddressChange, IdLocation: _this.IdLocation, LocationNumber: _this.LocationNumber, LocationName: _this.LocationName, LocationAddress: _this.completeaddress, LocationPhoneNumber: _this.LocationPhoneNumber, ContactPerson: _this.ContactPerson, ContactPersonEmailId: _this.ContactPersonEmailId, ContactPersonPhoneNumber: _this.ContactPersonPhoneNumber, CommisiionSplitType: _this.CommisiionSplitType, CurrencyType: _this.sel_currency, CommisiionSplit: _this.CommisiionSplit, CreatedBy: _this.IdMerchant, WorkingDays: _this.newselcteddays, StartTime: _this.StartTime, EndTime: _this.EndTime, Longitude: _this.long, Latitude: _this.lat, TimeZoneId: _this.timezoneid, dstOffset: _this.dstOffset, rawOffset: _this.rawOffset, StreetAddress: street_address, City: _this.cityname_auto, State: _this.statename_auto, Country: _this.countryname, Zipcode: _this.postal_code_auto, IdChain: _this.optionsModelChain, LocationImageName: _this.Name, Bio: _this.LocationBio, Weblink: _this.LocationWeblink, AddressValidated: _this.AddressValidated, IdCountry: _this.IdCountry, IdState: _this.IdState, IdCity: _this.IdCity }, _this.globalservice.Headers())
                        .take(1)
                        .timeout(25000)
                        .map(function (resp) {
                        if (resp == null || resp.Response == null) {
                            throw { Response: 0, ErrorMessage: 'Null Response' };
                        }
                        resp.Response = +resp.Response;
                        if (resp.Response !== 1) {
                            throw resp;
                        }
                        return resp;
                    })
                        .subscribe(function (response) {
                        _this.router.navigate([_this.companyName + '/dashboard/locations']);
                    }, function (err) {
                        var Error = _this.globalservice.ProcessError(err);
                        if (Error.Response === 35) {
                            if (Error.ErrorMessage) {
                                _this.FlashError(Error.ErrorMessage);
                                _this.globalservice.Logout('Yes');
                            }
                            _this.globalservice.Logout('No');
                            return;
                        }
                        else {
                            _this.FlashError(Error.ErrorMessage);
                            return;
                        }
                    }).add(function () { $('#dots_spinner').hide(); });
                }
                else {
                    _this.FlashError('Firstly upload location Image');
                }
            }
            else {
                _this.FlashError('Address is not validated');
            }
        }, 2000);
    };
    // }
    // get chains
    UpdatelocationComponent.prototype.refreshChainlist = function () {
        var _this = this;
        $('#dots_spinner').show();
        // console.log(this.globalservice.Headers())
        this.http.post(this.apiList.MerchantChains, {}, this.globalservice.Headers())
            .timeout(25000)
            .take(1)
            .map(function (response) {
            if (!response) {
                throw { Response: 0, ErrorMessage: 'Empty Response' };
            }
            if (response.Response !== 1) {
                throw response;
            }
            return response;
        })
            .subscribe(function (response) {
            if (response) {
                console.log("merchant chain list" + JSON.stringify(response));
                _this.chainList = response.Chains;
                $('#dots_spinner').hide();
            }
        }, function (err) {
            var Error = _this.globalservice.ProcessError(err);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                    $('#dots_spinner').hide();
                }
                _this.globalservice.Logout('No');
                $('#dots_spinner').hide();
                return;
            }
            else {
                $('#dots_spinner').hide();
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        }).add(function () {
            $('#dots_spinner').hide();
        });
    };
    UpdatelocationComponent.prototype.onChangechain = function (id) {
        this.optionsModelChain = id;
    };
    UpdatelocationComponent.prototype.addNewChain = function () {
        this.chainName = "";
        console.log("inside modal open");
        $('#addChain').modal('show');
    };
    UpdatelocationComponent.prototype.AddChainData = function () {
        var _this = this;
        // this.productForm.value.SalesTaxAmount
        $('#dots_spinner').show();
        this.http.post(this.apiList.AddChain, { Name: this.chainName }, this.globalservice.Headers())
            .timeout(25000)
            .take(1)
            .map(function (response) {
            if (!response) {
                throw { Response: 0, ErrorMessage: 'Empty Response' };
            }
            if (response.Response !== 1) {
                throw response;
            }
            return response;
        })
            .subscribe(function (response) {
            // this.list = response;
            _this.FlashError('Successfully Added');
            _this.refreshChainlist();
        }, function (err) {
            var Error = _this.globalservice.ProcessError(err);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                }
                _this.globalservice.Logout('No');
                return;
            }
            else {
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        }).add(function () {
            $('#dots_spinner').hide();
            $('#addChain').modal('hide');
            _this.chainName = "";
            // if (this.Resizing) {
            //   // need to give time to render behind the scenes before size/resize rows	        // need to give time to render behind the scenes before size/resize rows
            //   this.SettleAndAutosize(500);
            // }
        });
    };
    UpdatelocationComponent.prototype.close_addchain = function () {
        $('#addChain').modal('hide');
        this.chainName = "";
    };
    UpdatelocationComponent.prototype.MainImageUpload = function (file) {
        this.blob = new Blob([file[0]], { type: file[0].type });
        console.log(file);
        this.uploadFile();
    };
    UpdatelocationComponent.prototype.uploadFile = function () {
        var _this = this;
        $('#dots_spinner').show();
        this.globalservice.uploadFiles(this.blob).then(function (res) {
            if (res.Response == 1) {
                $('#dots_spinner').hide();
                _this.upload_image = 1;
                _this.locNamee = res.PreviewUrl;
                _this.Name = res.FileName;
                $('#myImg').show(2000, function () {
                    $('#main_img_close').show();
                    $('#uploadSuccess').modal('show');
                });
                $('#upload-btn-wrapper').hide();
            }
        }, function (error) {
            var Error = _this.globalservice.ProcessError(error);
            if (Error.Response === 35) {
                if (Error.ErrorMessage) {
                    _this.FlashError(Error.ErrorMessage);
                    _this.globalservice.Logout('Yes');
                }
                _this.globalservice.Logout('No');
                return;
            }
            else {
                console.log(Error.ErrorMessage);
                // event.target.value = null;
                _this.FlashError(Error.ErrorMessage);
                return;
            }
        });
    };
    UpdatelocationComponent.prototype.remove = function () {
        this.locNamee = '';
        this.upload_image = '';
        // this.myInputVariable.nativeElement.value = '';
        $('#myImg').hide();
        $('#main_img_close').hide();
        $('#upload-btn-wrapper').show();
    };
    UpdatelocationComponent.prototype.ZipcodeExist = function () {
        var _this = this;
        console.log("iinside zip exists");
        if (this.selectedcity) {
            this.http.post(this.apiList.CheckZipCodeExist, { ZipCode: this.Zip, IdCity: this.selectedcity }, this.globalservice.headerWithoutauth())
                .subscribe(function (response) {
                if (response) {
                    if (response.Response === 1) {
                        _this.Latitude = response.Latitude;
                        _this.Longitude = response.Longitude;
                        _this.AddressValidated = true;
                        console.log("iinside zip exists valuid");
                    }
                    else if (response.Response === 4) {
                        // this.AlertText = "The zip code "+  this.Zip  +" is not recognized, are you sure?";
                        // $('#myModal').modal('show');
                        _this.checkZipGoogleApi();
                    }
                    else {
                        _this.FlashError("There was an internal error processing this zip code");
                    }
                }
            }, function (err) {
                console.log("iinside zip error");
                var Error = _this.globalservice.ProcessError(err);
                if (Error.Response === 35) {
                    if (Error.ErrorMessage) {
                        _this.FlashError(Error.ErrorMessage);
                        _this.globalservice.Logout('Yes');
                    }
                    _this.globalservice.Logout('No');
                    return;
                }
                else {
                    _this.FlashError(Error.ErrorMessage);
                    return;
                }
            });
        }
        else {
            this.Latitude = '';
            this.Longitude = '';
            this.AddressValidated = false;
            this.timezoneid = '';
            this.dstOffset = '';
            this.rawOffset = '';
            this.FlashError('Please select city first');
        }
    };
    UpdatelocationComponent.prototype.checkZipGoogleApi = function () {
        var _this = this;
        console.log("iinside zip exists check google");
        if (this.Zip && this.Zip !== "") {
            this.zipValidationAddress = this.selectedcity + " " + this.Zip;
            // this.completeaddress2 = this.LocationAddressmanully + "," + this.selectedcity + ", " + this.selectedstate + " " + this.Zip + " " + this.selctedcountry;
            // //console.log(this.completeaddress);
            this.zipValidationAddress = this.zipValidationAddress.replace(/  +/g, ' ');
            // this.completeaddress = this.selectedcity + ", " + this.selectedstate + " " + this.Zip + " " + this.selectedcountry;
            // // this.completeaddress2 = this.LocationAddressmanully + "," + this.selectedcity + ", " + this.selectedstate + " " + this.Zip + " " + this.selctedcountry;
            // //console.log(this.completeaddress);
            // this.completeaddress = this.completeaddress.replace(/  +/g, ' ');
            // this.completeaddress = this.selectedcity + ", " + this.selectedstate + " " + this.Zip + " " + this.selectedcountry;
            // // this.completeaddress2 = this.LocationAddressmanully + "," + this.selectedcity + ", " + this.selectedstate + " " + this.Zip + " " + this.selctedcountry;
            // //console.log(this.completeaddress);
            // this.completeaddress = this.completeaddress.replace(/  +/g, ' ');
            this.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + this.zipValidationAddress + "&key=AIzaSyA5I34koi9SnHUU6R5Ps7OcdAzkLi1w_I8").subscribe(function (response) {
                _this.geometry_address = response;
                if (_this.geometry_address.status == "OK") {
                    var lat = _this.geometry_address.results[0].geometry.location.lat;
                    var long = _this.geometry_address.results[0].geometry.location.lng;
                    _this.AddressValidated = true;
                    _this.GetTimezoneID(lat, long);
                }
                else {
                    _this.Latitude = '';
                    _this.Longitude = '';
                    _this.timezoneid = '';
                    _this.dstOffset = '';
                    _this.rawOffset = '';
                    _this.AddressValidated = false;
                    _this.FlashError("Invalid Zip Code");
                }
            });
        }
        else {
            this.Latitude = '';
            this.Longitude = '';
            this.timezoneid = '';
            this.dstOffset = '';
            this.rawOffset = '';
            this.AddressValidated = false;
            this.FlashError("Set up Edit address");
        }
    };
    return UpdatelocationComponent;
}());
export { UpdatelocationComponent };
